import React from 'react'

import firstImage from '../../../assets/img/mulher.png'

const Clients: React.FC = () => {
  return (
    <div className="row panel client-group margin-top-16">
      <div className="row ">
        <img
          src=
            {firstImage}
          alt="Cliente"
        />
        <div className="grow padding-left-16">
          <p>Amanda Cabral</p>
          <p>amanda.cabral@gmail.com</p>
        </div>
        <div className="grow">
          <p>Telefone</p>
          <p>(64)9 99999-9999</p>
        </div>

        <div className="grow">
          <p>Data de Nascimento</p>
          <p>22/02/1982</p>
        </div>

        <div className="grow">
          <p>Genero</p>
          <p>Feminino</p>
        </div>

      </div>
      <span style={{
        width: 54,
        height: 54,
        borderRadius: '50%',
        position: 'absolute',
        right: -25
      }} className="button primary search-some">
        <i className="far fa-2x fa-edit"></i>
      </span>
    </div>
  )
}
export default Clients
